import React, { FunctionComponent, HTMLAttributes } from 'react';

import { HiArrowNarrowLeft } from 'react-icons/hi';
import { IoIosRemoveCircleOutline } from 'react-icons/io';
import { IoFilterOutline } from 'react-icons/io5';

import Button from '@/tayara-kit/Button';
import Text from '@/tayara-kit/Text';

interface ScaffoldProps extends HTMLAttributes<HTMLDivElement> {
  children: JSX.Element | JSX.Element[];
  onResetFilter: () => void;
  setIsOpen: any;
  isOpen: any;
}

const NarrowFilterScaffold: FunctionComponent<ScaffoldProps> = ({
  children,
  setIsOpen,
  isOpen,
  onResetFilter,
}) => (
  <div className="w-full lg:w-[calc(100vw/3.8)] px-2 md:px-3 lg:px-4 lg:overflow-hidden overflow-scroll bg-white md:bg-transparent">
    <div className="w-full border py-4 px-4 mb-16 lg:mb-2 rounded-xl shadow-sm border-gray-100 bg-white mt-2">
      {/* Filter header */}
      {isOpen ? (
        <div className={`lg:mt-[9rem] flex items-center justify-between`}>
          <Button
            aria-label="Retour"
            onClick={() => {
              setIsOpen(false);
            }}
            className="btn-outline btn-sm text-2xs font-normal text-gray-700 bg-gray-100 border-gray-300
            hover:bg-gray-100 hover:text-gray-800 hover:border-gray-500 min-w-max"
            icon={<HiArrowNarrowLeft size={16} />}
          >
            <Text text="Retour" className="mx-1" />
          </Button>

          <Button
            aria-label="Réinitialiser le filtre"
            onClick={onResetFilter}
            className="btn-ghost btn-xs hover:bg-transparent text-neutral-600 font-medium 
          hover:text-gray-800 normal-case !gap-0"
            icon={<IoIosRemoveCircleOutline size={12} className="mx-2" />}
          >
            Réinitialiser
          </Button>
        </div>
      ) : (
        <div className="flex flex-wrap items-center justify-between py-2">
          <span className="flex items-center text-xs font-normal text-gray-600 space-x-2">
            <IoFilterOutline size={14} />
            <span>Filtres avancés</span>
          </span>
          <Button
            aria-label="Réinitialiser le filtre"
            onClick={onResetFilter}
            className=" !p-0 btn-ghost btn-xs hover:bg-transparent text-gray-600 
          hover:text-gray-800 font-normal normal-case !gap-0"
            icon={<IoIosRemoveCircleOutline size={16} />}
          >
            Réinitialiser
          </Button>
        </div>
      )}

      <div className="my-1 flex flex-col  relative">
        {/* Inputs */}
        {children}
      </div>
    </div>
  </div>
);

export default NarrowFilterScaffold;
